/**
 * @description: 权限处理方法，供各个组件继承使用
 * @author: linyu
 * @date: 2024-09-05 16:07
 */
import globalUtils from "../utils/global";
export default {
    props: {
        loading: { // 按钮加载标识
            type: Boolean,
            default: false
        },
        pID: { // 按钮权限标识，外部使用者传入
            type: String,
            default: ''
        }
    },

    data() {
        return {
            visible: false
        }
    },
    methods: {
        handleClick: function () {
            // 按钮操作处理函数
            this.$emit('click', {});
        },
        hasPermission: function () {
            return globalUtils.getPermission(this.pID, this.bizActionListKey);
        },
    },
    mounted() {},
    created() {
        this.visible = this.pID && this.hasPermission();
    },
    computed: {},
}
